export enum DrView {
  Analytics = 'analytics',
  Chat = 'chat',
  ActionPlan = 'action-plan',
  Settings = 'settings',
  Content = 'content',
  Files = 'files',
  Resource = 'resource',
}
